import React, { useState, useEffect, useCallback } from 'react';
import api from '../../services/api';

// Jenn, 2026-10-08: views from her personal Facebook "Content" screen go into
// Sales & Marketing. Her personal account isn't in Metricool, so the numbers
// are typed in here (all-time views as of the day they're copied). Adding the
// same post (same date/time and title) again just updates its views.
const fmt = (iso) => new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
const KINDS = ['Post', 'Photo', 'Reel', 'Video', 'Story'];
const blank = { postedAt: '', title: '', kind: 'Post', place: 'Profile', views: '' };

export default function PersonalFacebookViews({ Card }) {
  const [posts, setPosts] = useState(null);
  const [f, setF] = useState(blank);
  const [msg, setMsg] = useState('');
  const [showAll, setShowAll] = useState(false);

  const load = useCallback(() => {
    api.get('/admin/sales-marketing/personal-views').then(r => setPosts(r.data.posts)).catch(() => setPosts([]));
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async (e) => {
    e.preventDefault();
    setMsg('');
    try {
      await api.post('/admin/sales-marketing/personal-views', { ...f, postedAt: new Date(f.postedAt).toISOString(), views: Number(f.views) });
      setF(blank);
      setMsg('Saved.');
      load();
    } catch (err) {
      setMsg(err.response?.data?.error || 'Could not save that.');
    }
  };
  const remove = async (id) => {
    if (!window.confirm('Remove this post from the list?')) return;
    await api.delete(`/admin/sales-marketing/personal-views/${id}`).catch(() => {});
    load();
  };

  const list = posts || [];
  const total = list.reduce((s, p) => s + p.views, 0);
  const top = [...list].sort((a, b) => b.views - a.views).slice(0, 5);
  const asOf = list.length ? list.reduce((a, p) => (new Date(p.views_as_of) > new Date(a) ? p.views_as_of : a), list[0].views_as_of) : null;
  const shown = showAll ? list : list.slice(0, 10);
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));

  return (
    <Card live style={{ marginTop: 16 }}>
      <p className="q">Jenn's personal Facebook · views per post</p>
      <p className="qs">From Facebook's Content screen (all-time views){asOf ? ` · as of ${new Date(asOf).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}` : ''}</p>
      {posts && list.length === 0 && <div className="empty">No posts added yet. Add one below.</div>}
      {list.length > 0 && (
        <>
          <div className="bign">{total.toLocaleString()}</div>
          <div className="lbl">views across {list.length} posts</div>
          <p className="qs" style={{ marginTop: 12 }}>Most viewed</p>
          {top.map(p => (
            <div key={p.id} className="one" style={{ marginTop: 6 }}>
              <div className="t"><span>{p.title || `${p.kind} · ${fmt(p.posted_at)}`}</span><b>{p.views}</b></div>
              <div className="track"><div className="fill" style={{ width: `${Math.round((p.views / top[0].views) * 100)}%`, background: 'var(--terra)' }} /></div>
            </div>
          ))}
          <table style={{ width: '100%', fontSize: 12, marginTop: 14, borderCollapse: 'collapse' }}>
            <thead><tr style={{ textAlign: 'left', color: '#888' }}><th>Posted</th><th>Post</th><th>Where</th><th style={{ textAlign: 'right' }}>Views</th><th /></tr></thead>
            <tbody>
              {shown.map(p => (
                <tr key={p.id} style={{ borderTop: '1px solid #eee' }}>
                  <td style={{ padding: '4px 6px 4px 0', whiteSpace: 'nowrap' }}>{fmt(p.posted_at)}</td>
                  <td style={{ padding: '4px 6px' }}>{p.title || <i style={{ color: '#999' }}>no title</i>} <span style={{ color: '#999' }}>· {p.kind}</span></td>
                  <td style={{ padding: '4px 6px', color: '#777' }}>{p.place}</td>
                  <td style={{ padding: '4px 0', textAlign: 'right', fontWeight: 600 }}>{p.views}</td>
                  <td style={{ paddingLeft: 6 }}><button type="button" className="btn s" onClick={() => remove(p.id)} title="Remove">×</button></td>
                </tr>
              ))}
            </tbody>
          </table>
          {list.length > 10 && <button type="button" className="btn s" style={{ marginTop: 8 }} onClick={() => setShowAll(v => !v)}>{showAll ? 'Show fewer' : `Show all ${list.length}`}</button>}
        </>
      )}
      <form onSubmit={save} style={{ marginTop: 16 }}>
        <p className="qs">Add a post, or update its views (same date, time and title)</p>
        <div className="row" style={{ flexWrap: 'wrap', gap: 8 }}>
          <label className="fld">Posted<input type="datetime-local" required value={f.postedAt} onChange={e => set('postedAt', e.target.value)} /></label>
          <label className="fld">First words of the post<input value={f.title} onChange={e => set('title', e.target.value)} placeholder="Leave blank if it has none" /></label>
          <label className="fld">Type<select value={f.kind} onChange={e => set('kind', e.target.value)}>{KINDS.map(k => <option key={k}>{k}</option>)}</select></label>
          <label className="fld">Where<input value={f.place} onChange={e => set('place', e.target.value)} placeholder="Profile, or the group's name" /></label>
          <label className="fld">Views<input type="number" min="0" required value={f.views} onChange={e => set('views', e.target.value)} /></label>
          <button type="submit" className="btn p s">Save</button>
        </div>
        {msg && <div className="note">{msg}</div>}
      </form>
    </Card>
  );
}
